import styled from 'styled-components'

const FileTab = styled.div`
  
`

export {FileTab}
